import React, { useEffect, useState } from "react";
import {
  GalleryCardContainer,
  GalleryTitle,
  GallerySubTitle,
  ButtonGallery,
} from "../../GalleryDetail.styled";
import { func } from "../../../../../utils";
import moment from "moment";

const imgPath = `${process.env.REACT_APP_API_HOST}uploads/featured-images/`;

const GalleryCard = ({ data, cardWidth = 0 }) => {
  const startDate = moment(data?.event_start_date);
  const endDate = moment(data?.event_end_date);

  const isSameMonthEvent = startDate.format("MMMM") === endDate.format("MMMM");
  const cardDate = isSameMonthEvent
    ? `${startDate?.format("D")} - ${endDate?.format("D MMMM")}`
    : `${startDate?.format("D MMMM")} - ${endDate?.format("D MMMM")}`;

  return (
    // @ts-ignore
    <div
      className={`group w-[207px] h-[393px] md:w-[279px] md:h-[454px] flex items-end rounded-2xl cursor-pointer !bg-[length:auto_100%] hover:!bg-[length:auto_115%] transition ease-in-out delay-150 hover:scale-101 duration-300`}
      style={{
        background: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 42.72%, rgba(0, 0, 0, 0.50) 71.31%, rgba(0, 0, 0, 0.90) 99.95%), url('${
          imgPath + data?.key_visual_gallery
        }') lightgray 50% / cover no-repeat`,
        transition: "background-size 0.5s ease-in",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: 16,
          gap: 12,
          width: cardWidth,
        }}
      >
        <img
          src={imgPath + data?.key_visual}
          style={{ width: 75, height: 64 }}
        />
        <GalleryTitle>{data?.region_name}</GalleryTitle>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
          }}
        >
          <GallerySubTitle>
            {" "}
            <span>
              <img
                src={func.getStaticImg("/icon/sa-calendar.svg")}
                style={{ height: 16, width: 16 }}
              />
            </span>{" "}
            {cardDate}
          </GallerySubTitle>

          <GallerySubTitle>
            <span>
              <img
                src={func.getStaticImg("/icon/sa-pin.svg")}
                style={{ height: 16, width: 16 }}
              />
            </span>
            {data?.event_location}
          </GallerySubTitle>
        </div>
        <ButtonGallery onClick={() => window.open(data?.parent_drive_url)}>
          Lihat Foto{" "}
          <span>
            <img
              src={func.getStaticImg("/icon/right-arrow-white.svg")}
              style={{
                height: 20,
                width: 20,
                marginLeft: 8,
                marginBottom: 3,
              }}
            />
          </span>{" "}
        </ButtonGallery>
      </div>
    </div>
  );
};

export default GalleryCard;
